import { render, staticRenderFns } from "./DrugOrdersInbox.vue?vue&type=template&id=44c6dee4&"
import script from "./DrugOrdersInbox.vue?vue&type=script&lang=js&"
export * from "./DrugOrdersInbox.vue?vue&type=script&lang=js&"
import style0 from "./DrugOrdersInbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports